import React from 'react';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 'app',
    name: 'iOS App',
    tagline: 'Scan labels in-store',
    description: 'Point your camera at any ingredient label. Get instant analysis of seed oils, artificial dyes, and additives.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    color: 'sage',
    colorClasses: {
      bg: 'bg-sage-100',
      text: 'text-sage-600',
      border: 'border-sage-200',
      button: 'bg-sage-500 hover:bg-sage-600',
    },
    cta: 'Get the App',
    link: '/app',
    badge: null,
  },
  {
    id: 'extension',
    name: 'Browser Extension',
    tagline: 'Shop cleaner online',
    description: 'Automatically scans products while you shop on Amazon, Walmart, Instacart, and more. No extra steps needed.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    color: 'teal',
    colorClasses: {
      bg: 'bg-teal-500/10',
      text: 'text-teal-600',
      border: 'border-teal-500/20',
      button: 'bg-teal-500 hover:bg-teal-600',
    },
    cta: 'Add to Chrome',
    link: '/extension',
    badge: null,
  },
  {
    id: 'meal-planner',
    name: 'AI Meal Planner',
    tagline: 'Plan clean meals',
    description: 'Get personalized meal plans that avoid your flagged ingredients. Built around your dietary needs and preferences.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
    color: 'warm',
    colorClasses: {
      bg: 'bg-warm-500/10',
      text: 'text-warm-600',
      border: 'border-warm-500/20',
      button: 'bg-warm-500 hover:bg-warm-600',
    },
    cta: 'Join Waitlist',
    link: '/meal-planner',
    badge: 'Coming Soon',
  },
];

function ProductCards() {
  return (
    <section id="products" className="bg-background py-16 md:py-20">
      <div className="section">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-12">
          <h2 className="section-heading">Choose How You Shop</h2>
          <p className="section-subheading mx-auto">
            Whether you're in the grocery aisle or browsing online, FoodLens has you covered.
          </p>
        </div>

        {/* Product Cards Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`product-card relative animate-fade-in-up`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Coming Soon Badge */}
              {product.badge && (
                <div className="absolute -top-3 -right-3 bg-coral-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
                  {product.badge}
                </div>
              )}

              {/* Icon */}
              <div className={`inline-flex p-4 rounded-2xl ${product.colorClasses.bg} ${product.colorClasses.text} mb-6`}>
                {product.icon}
              </div>

              {/* Content */}
              <h3 className="font-display text-2xl text-charcoal mb-2">{product.name}</h3>
              <p className={`text-sm font-medium ${product.colorClasses.text} mb-4`}>{product.tagline}</p>
              <p className="text-gray-500 leading-relaxed mb-6">{product.description}</p>

              {/* CTA */}
              <Link
                to={product.link}
                className={`inline-flex items-center justify-center px-6 py-3 rounded-xl text-white font-medium transition-all duration-200 ${product.colorClasses.button}`}
              >
                {product.cta}
                <svg className="w-4 h-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductCards;
